import React from 'react'
import { useState, useEffect } from 'react'
import { BackButton } from '@/components/layout/NavBar'
import { Services } from '@/services/services'
import { useParams } from 'react-router-dom'

import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { Translates } from '@/services/repository/i18n'
import { FailuresMapComponent } from '@/components/Map/FailuresMap'

import './MyFailureMap.css'

export const CommunalMyMachineFailuresMap = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const mid = useParams().mid
  const [translates, setTranslates] = useState<Translates>()

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='my-machine-failure-map' services={services} translates={translates} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <p className='description'>
      {translates.for('page.communal-machine-failure-map.description')}
    </p>
    <div className='default-map-container'>
      <FailuresMapComponent fetchUrl='/api/communal/my/failures/map' services={services} session={session} />
    </div>
  </MainPageLayout>
}
